import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import VDClogo from '../assets/logo.jpg';

const siteKey = '6LedyWwrAAAAACiVz8IQ2S5EWYL6j26r2Jbz6Hkk';
const BASE_URL = 'https://travelapp.vdcapp.in/backend/api';

const ForgetPassword = () => {
     const [bmId, setBmId] = useState('');
     const [otp, setOtp] = useState('');
     const [mobile, setMobile] = useState('');
     const [userBmId, setUserBmId] = useState('');
     const [isOTPsent, setIsOTPSent] = useState(false);
     const [isOTPVerified, setIsOTPVerified] = useState(false);
     const [newPassword, setNewPassword] = useState('');
     const [confirmPassword, setConfirmPassword] = useState('');

     const handleSubmit = (e) => {
          e.preventDefault();
          if (!bmId) {
               alert('Please enter your BM ID.');
               return;
          }

          setUserBmId(bmId);

          fetch(`${BASE_URL}/passwordChangeRequest`, {
               method: 'POST',
               headers: { 'Content-Type': 'application/json' },
               body: JSON.stringify({ bmId }),
          })
               .then((res) => res.json())
               .then((data) => {
                    if (!data.status) {
                         alert('Error: ' + data.message);
                         return;
                    }
                    setMobile(data.data.mobile);
                    setIsOTPSent(true);
                    setOtp('');
                    alert('OTP sent successfully! Please check your Mobile WhatsApp.');
                    setBmId('');
               })
               .catch(console.error);
     };

     const handleOTPSubmit = (e) => {
          e.preventDefault();
          if (!otp || !mobile) {
               alert('Please enter a valid OTP.');
               return;
          }

          fetch(`${BASE_URL}/verifyOTP`, {
               method: 'POST',
               headers: { 'Content-Type': 'application/json' },
               body: JSON.stringify({ otp, mobile }),
          })
               .then((res) => res.json())
               .then((data) => {
                    if (data.status) {
                         alert('OTP verified successfully!');
                         setIsOTPVerified(true);
                    } else {
                         if (data.message === 'OTP expired') {
                              alert('OTP expired. Please request again.');
                              setIsOTPSent(false);
                              setBmId('');
                         } else {
                              alert(data.message || 'Invalid OTP.');
                         }
                    }
               })
               .catch(console.error);
     };

     const handleNewPasswordSubmit = (e) => {
          e.preventDefault();

          if (!newPassword || !confirmPassword) {
               alert('Please fill both password fields.');
               return;
          }

          if (newPassword !== confirmPassword) {
               alert('Passwords do not match.');
               return;
          }

          fetch(`${BASE_URL}/resetPassword`, {
               method: 'POST',
               headers: { 'Content-Type': 'application/json' },
               body: JSON.stringify({ newPassword, bmId: userBmId }),
          })
               .then((res) => res.json())
               .then((data) => {
                    if (data.status) {
                         alert('Password reset successfully!');
                         window.location.href = '/';
                    } else {
                         alert('Error: ' + data.message);
                    }
               })
               .catch(console.error);

          // Cleanup
          setBmId('');
          setIsOTPSent(false);
          setIsOTPVerified(false);
          setMobile('');
          setOtp('');
          setNewPassword('');
          setConfirmPassword('');
     };

     useEffect(() => {
          if (isOTPVerified) {
               setOtp('');
               setNewPassword('');
               setConfirmPassword('');
          }
     }, [isOTPVerified]);

     const styles = {
          container: {
               height: '100vh',
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'center',
               backgroundColor: '#f0f2f5',
          },
          card: {
               backgroundColor: '#fff',
               padding: '30px',
               borderRadius: '10px',
               boxShadow: '0 0 10px rgba(0,0,0,0.1)',
               width: '100%',
               maxWidth: '400px',
          },
          logo: {
               display: 'block',
               margin: '0 auto 10px',
               width: '300px',
          },
          heading: {
               textAlign: 'center',
               fontWeight: 'bold',
               marginBottom: '5px',
          },
          input: {
               width: '100%',
               padding: '10px',
               marginBottom: '15px',
               border: '1px solid #ccc',
               borderRadius: '5px',
          },
          button: {
               width: '100%',
               padding: '10px',
               backgroundColor: '#28a745',
               color: 'white',
               border: 'none',
               borderRadius: '5px',
               cursor: 'pointer',
          },
     };

     return (
          <div style={styles.container}>
               {isOTPVerified ? (
                    <div style={styles.card}>
                         <img src={VDClogo} alt="VDC Logo" style={styles.logo} />
                         <h2 style={styles.heading}>🔒 Set New Password</h2>
                         <form onSubmit={handleNewPasswordSubmit}>
                              <label>New Password</label>
                              <input
                                   type="password"
                                   name="newPassword"
                                   style={styles.input}
                                   placeholder="Enter your new password"
                                   value={newPassword}
                                   onChange={(e) => setNewPassword(e.target.value)}
                                   required
                              />
                              <label>Confirm Password</label>
                              <input
                                   type="password"
                                   name="confirmPassword"
                                   style={styles.input}
                                   placeholder="Confirm your new password"
                                   value={confirmPassword}
                                   onChange={(e) => setConfirmPassword(e.target.value)}
                                   required
                              />
                              <button type="submit" style={styles.button}>
                                   Reset Password
                              </button>
                         </form>
                    </div>
               ) : isOTPsent ? (
                    <div style={styles.card}>
                         <img src={VDClogo} alt="VDC Logo" style={styles.logo} />
                         <h2 style={styles.heading}>🔒 Enter OTP</h2>
                         <form onSubmit={handleOTPSubmit}>
                              <label>OTP</label>
                              <input
                                   type="number"
                                   name="otp"
                                   style={styles.input}
                                   placeholder="Enter the OTP sent to your WhatsApp"
                                   value={otp}
                                   onChange={(e) => setOtp(e.target.value)}
                                   required
                              />
                              <button type="submit" style={styles.button}>
                                   Verify OTP
                              </button>
                         </form>
                    </div>
               ) : (
                    <div style={styles.card}>
                         <img src={VDClogo} alt="VDC Logo" style={styles.logo} />
                         <h2 style={styles.heading}>🔒 Forgot Password</h2>
                         <form onSubmit={handleSubmit}>
                              <label>BM ID</label>
                              <input
                                   type="number"
                                   name="bmId"
                                   style={styles.input}
                                   placeholder="Enter your BM ID"
                                   value={bmId}
                                   onChange={(e) => setBmId(e.target.value)}
                                   required
                              />
                              <button type="submit" style={styles.button}>
                                   Submit
                              </button>
                         </form>
                    </div>
               )}
          </div>
     );
};

export default ForgetPassword;
